(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jacc-howard-miller-personalization"] && !Shopify.designMode) return;
  try {
    (() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('personalization_quote') !== 'sent') return;
    const quote = document.querySelector('[data-jacc-personalization-quote]');
    if (!quote) return;
    const panel = quote.closest('[data-jacc-personalization]');
    if (panel) panel.open = true;
    quote.open = true;
    const status = quote.querySelector('[role="status"], [role="alert"]');
    if (status) status.focus();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jacc-tourbillon-film"] && !Shopify.designMode) return;
  try {
    const initializeTourbillonFilms = root => {
    root.querySelectorAll('[data-tourbillon-player]').forEach(player => {
      if (player.dataset.tourbillonReady === 'true') return;

      const button = player.querySelector('[data-tourbillon-play]');
      const videoId = player.dataset.videoId;
      const videoProvider = player.dataset.videoProvider;
      const videoSrc = player.dataset.videoSrc;

      if (!button) return;
      if (videoProvider === 'native' && !videoSrc) return;
      if (videoProvider !== 'native' && !videoId) return;

      player.dataset.tourbillonReady = 'true';

      button.addEventListener('click', () => {
        const showFilm = () => {
          if (videoProvider === 'native') {
            const video = document.createElement('video');
            video.src = videoSrc;
            video.controls = true;
            video.autoplay = true;
            video.playsInline = true;
            video.preload = 'metadata';
            video.setAttribute('aria-label', player.dataset.videoTitle || button.getAttribute('aria-label'));
            player.replaceChildren(video);
            video.focus();

            const playback = video.play();
            if (playback) playback.catch(() => {});
            return;
          }

          const iframe = document.createElement('iframe');
          iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?autoplay=1&rel=0&modestbranding=1&playsinline=1`;
          iframe.title = player.dataset.videoTitle || button.getAttribute('aria-label');
          iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
          iframe.allowFullscreen = true;
          iframe.referrerPolicy = 'strict-origin-when-cross-origin';
          player.replaceChildren(iframe);
          iframe.focus();
        };

        if (videoProvider === 'native') {
          showFilm();
        } else if (document.startViewTransition) {
          document.startViewTransition(showFilm);
        } else {
          showFilm();
        }
      }, { once: true });
    });
  };

  initializeTourbillonFilms(document);

  document.addEventListener('shopify:section:load', event => {
    initializeTourbillonFilms(event.target);
  });
  } catch(e) { console.error(e); }
})();

})();
